import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, ColumnSeries, Category, DataLabel, Tooltip, Legend } from '@syncfusion/ej2-react-charts';
import { FacilityCenterBreakdownView } from '../../../../services/ReportingService';

interface TicketsByLocationChartProps {
  centerData: FacilityCenterBreakdownView[];
}

const TicketsByLocationChart: React.FC<TicketsByLocationChartProps> = ({ centerData }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Tickets by Location
        </Typography>
        {centerData.length > 0 ? (
          <ChartComponent
            id="tickets-by-center"
            primaryXAxis={{ valueType: 'Category' }}
            primaryYAxis={{ title: 'Ticket Count' }}
            tooltip={{ enable: true }}
            height="300px"
          >
            <Inject services={[ColumnSeries, Category, DataLabel, Tooltip, Legend]} />
            <SeriesCollectionDirective>
              <SeriesDirective
                dataSource={centerData}
                xName="centerName"
                yName="ticketCount"
                type="Column"
                name="Tickets"
                fill="#3b82f6"
              />
            </SeriesCollectionDirective>
          </ChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TicketsByLocationChart;
